import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

const stringEvent = (string) => {
  if(string.split(' | ').length > 1) {
    return string.split(' | ')[1]
  } else {
    return string;
  }
}

class RenderEvent extends Component {

  ordinalSuffix(i) {
    var j = i % 10,
        k = i % 100;
    if (j === 1 && k !== 11) {
        return i + "st";
    }
    if (j === 2 && k !== 12) {
        return i + "nd";
    }
    if (j === 3 && k !== 13) {
        return i + "rd";
    }
    return i + "th";
  }

  render() {
    if(!this.props.args.cellData) return '-';

    let realEvent = JSON.parse(this.props.args.cellData);
    let actualEvent;
    if(this.props.eventConfig) {
      let aim = this.props.eventConfig.event_ids[this.props.workoutIdx - 1];
      realEvent.map(event => {
        if(event.EventId === aim) return actualEvent = event;
        return '';
      })
    } else {
      return '';
    }
    
    if(!actualEvent) return '-';
    return(
      <Grid 
        container
        justify="space-around"
        spacing={16}>
        <Grid 
          item 
          className={'overflow-hack'}
          sm={12}
          xs={12}
          data-tip={actualEvent.ScoreRankingPhrase}>
          <strong>{this.ordinalSuffix(actualEvent.PlaceRank)}</strong> ({stringEvent(actualEvent.ScoreRankingPhrase)}) 
          {actualEvent.ScorePenaltyPhrase &&
            <span className="red">*</span>
          }
        </Grid>
      </Grid>
    )
  }
}

RenderEvent.propTypes = {
  args: PropTypes.object.isRequired,
  workoutIdx: PropTypes.number.isRequired
}

export default RenderEvent;